import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

interface Order {
  Id: number;  // Database ID
  orderId: number;  // 6-digit order ID
  phone: string;
  email: string;
  brideName: string;
  Note: string;
  weddingDate: string;
  requiredDate: string;
  deliverTo: string;
  sendAddress: string;
  process: string;
  name: string;
  orderItem: string;
  Clients: number;
  shipping: string;
  trackingNumber: string;
}

interface OrderTableProps {
  orders: Order[];
}

const OrderTable = ({ orders }: OrderTableProps) => {
  console.log('Orders received in table:', orders); // Debug log

  const getStatusColor = (status: string | undefined) => {
    if (!status) return "bg-gray-500";
    
    switch (status.toLowerCase()) {
      case "new":
        return "bg-blue-500";
      case "contact client":
        return "bg-yellow-500";
      case "processing":
        return "bg-purple-500";
      case "deliver":
        return "bg-orange-500";
      case "done":
        return "bg-green-500";
      default:
        return "bg-gray-500";
    }
  };

  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      // Format: DD-MM-YYYY
      return date.toLocaleDateString('id-ID', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch (e) {
      return "Invalid Date";
    }
  };

  const getEmptyFieldMessage = (fieldName: string) => {
    return `No ${fieldName.toLowerCase()} provided`;
  };

  if (!orders || orders.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg">
        <p className="text-gray-600 text-lg">No orders found</p>
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Order ID</TableHead>
            <TableHead>Bride's Name</TableHead>
            <TableHead>Wedding Date</TableHead>
            <TableHead>Required Date</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Items</TableHead>
            <TableHead>Shipping</TableHead>
            <TableHead>Tracking Number</TableHead>
            <TableHead>Notes</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {orders?.map((order) => {
            console.log('Rendering order:', order); // Debug each order
            return order && (
              <TableRow key={order.Id}>
                <TableCell>{order?.orderId || getEmptyFieldMessage('Order ID')}</TableCell>
                <TableCell>{order?.brideName || getEmptyFieldMessage('Bride Name')}</TableCell>
                <TableCell>{formatDate(order?.weddingDate) === 'N/A' ? getEmptyFieldMessage('Wedding Date') : formatDate(order?.weddingDate)}</TableCell>
                <TableCell>{formatDate(order?.requiredDate) === 'N/A' ? getEmptyFieldMessage('Required Date') : formatDate(order?.requiredDate)}</TableCell>
                <TableCell>
                  <Badge className={`${getStatusColor(order?.process)} text-white`}>
                    {order?.process || getEmptyFieldMessage('Status')}
                  </Badge>
                </TableCell>
                <TableCell>{order?.orderItem || getEmptyFieldMessage('Items')}</TableCell>
                <TableCell>{order?.shipping || "Processing"}</TableCell>
                <TableCell>{order?.trackingNumber || "Processing"}</TableCell>
                <TableCell>{order?.Note || getEmptyFieldMessage('Notes')}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default OrderTable;
